import { Hero04books } from './Images.js';
import HeaderMenu from './HeaderMenu.js';
import LazyImage from './components/LazyImage';
import HeroImage from './components/HeroImage';
import './css/App.css';
import './css/Books.css';
import BookCard from './BookCard.js';
import { Link, Outlet } from 'react-router-dom';

//images 
import { BookBigExperiments } from './Images.js';
import { useDocumentTitle } from "./hooks/useDocumentTitle";
import { useMediaQuery } from 'react-responsive';

//bookdata
import { BookOne, BookTwo, BookThree, BookEight} from './BookData';

function BookOneX() {
  return (
    <BookCard bookimage={BookOne.image} booktitle={BookOne.title} booksubtitle={BookOne.subtitle} bookdescription={BookOne.desc} booklinks={BookOne.links} />
  )
}

function Books() {

  useDocumentTitle("Books");
  const isMobile = useMediaQuery({ query: `(max-width: 960px)` });

  return (
      <div className="sectionbody"> 
        <HeaderMenu />

        <div className={isMobile ? "hero-image-area-mobile" : "hero-image-area"}>
            <HeroImage 
                src={Hero04books} 
                alt="Books by Kate the Chemist"
            />
        </div>

        <div className={isMobile ? "intro-paragraph-area-mobile" : "intro-paragraph-area"}>
          
            <h1>Books</h1>
            <h2><em>"In the pages of this essential book you'll discover the great wonder of chemistry."</em></h2>
            <p>
            —Bill Nye on <em>'It's Elemental'</em> by Dr. Kate Biberdorf
            </p>
          
        </div>

        <div className="blue-bg-area">
          <div className={isMobile ? "book-thumbnails-mobile" : "book-thumbnails"}>
            
            <Link to={`/books/bookone`}>
              <LazyImage 
                  className={isMobile ? "book-thumbnail-mobile" : "book-thumbnail"} 
                  src={BookOne.image} 
                  alt={`Cover of ${BookOne.title}`}
              />
            </Link>
            <Link to={`/books/booktwo`}>
              <LazyImage 
                  className={isMobile ? "book-thumbnail-mobile" : "book-thumbnail"} 
                  src={BookTwo.image} 
                  alt={`Cover of ${BookTwo.title}`}
              />
            </Link>
            <Link to={`/books/bookthree`}>
              <LazyImage 
                  className={isMobile ? "book-thumbnail-mobile" : "book-thumbnail"} 
                  src={BookThree.image} 
                  alt={`Cover of ${BookThree.title}`}
              />
            </Link>
            <Link to={`/books/bookeight`}>
              <LazyImage 
                  className={isMobile ? "book-thumbnail-mobile" : "book-thumbnail"} 
                  src={BookEight.image} 
                  alt={`Cover of ${BookEight.title}`}
              />
            </Link>
            
          </div>
          <div className="books2">
            
              <Outlet />
            
          </div>
        </div>

      </div>
  );
}

export default Books;
